<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <nav-bar :title="$t('提现')" bgColor="#000000">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="16" @click.stop="$router.replace('zichan')" />
      </template>
    </nav-bar>

    <div-padding padding="4vw">
      <div-card height="35vw" padding='3vw'>
        <div-height height='5vw' />
        <template v-if="active == 1 || active == 2">
          <div-text color='#fff' align="center" size='7vw'>
            {{ usdt }}
          </div-text>
          <div-text color='#999' align="center" size='3.5vw'>{{ $t('可用') }} USDT</div-text>
        </template>
        <template v-if="active == 3">
          <div-text color='#fff' align="center" size='7vw'>
            {{ act }}
          </div-text>
          <div-text color='#999' align="center" size='3.5vw'>{{ $t('可用') }} ACT</div-text>
        </template>
      </div-card>

      <template v-if="taplist.length > 0">
        <van-tabs v-model="active" sticky offset-top="12.3vw" background="#0F0F0F" color="#E6B17F"
          title-inactive-color="#808080" title-active-color="#E6B17F">
          <van-tab :title="val.name" :name="val.id" v-for="val in taplist" :key="val.id">
            <div v-if="active == 1">
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' type="number" clearable :formatter="formatter" v-model='num'
                    :placeholder='`${$t("最小提现数量")}(${info.withdraw_min || 0})`'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('提现数量') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' clearable v-model='address' :placeholder='$t("请输入提现地址")'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('提现地址') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <div-flex left>
                    <div-width width='24vw'>
                      <div-text size='4vw' color='#FFFFFF'>{{ $t('手续费') }}{{ info.withdraw_fee || 0 }}%</div-text>
                    </div-width>
                    <div-text size='4vw' color='#CEB082'>{{ getfee }}</div-text>
                  </div-flex>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' readonly clearable :value="getnum" :placeholder='$t("自动计算")'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('实际到账') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='8vw' />
              <div-btn @click.native="one()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
                <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
              </div-btn>
              <div-height height='10vw' />
            </div>
            <div v-if="active == 3">
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' type="number" clearable :formatter="formatter" v-model='num'
                    :placeholder='`${$t("最小提现数量")}(${info.act_withdraw_min || 0})`'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('提现数量') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' clearable v-model='address' :placeholder='$t("请输入提现地址")'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('提现地址') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <div-flex left>
                    <div-width width='24vw'>
                      <div-text size='4vw' color='#FFFFFF'>{{ $t('手续费') }}{{ info.act_withdraw_fee || 0 }}%</div-text>
                    </div-width>
                    <div-text size='4vw' color='#CEB082'>{{ getACTfee }}</div-text>
                  </div-flex>
                </div-card>
              </div-input>
              <div-height height='8vw' />
              <div-btn @click.native="one()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
                <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
              </div-btn>
              <div-height height='10vw' />
            </div>
            <div v-if="active == 2">
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' type="number" clearable :formatter="formatter" v-model='num'
                    :placeholder='`${$t("最小提现数量")}(${info.withdraw_min || 0})`'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('提现数量') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <template v-if="info.has_card == 1">
                <div-input>
                  <div-card bg="#242424" padding='3vw' radius='2vw'>
                    <van-field :border='false' clearable v-model='bankinfo.surname' readonly>
                      <template #label>
                        <div-width width='20vw'>
                          <div-text size='4vw' color='#FFFFFF'>{{ $t('姓名') }}</div-text>
                        </div-width>
                      </template>
                    </van-field>
                  </div-card>
                </div-input>
                <div-height height='3vw' />
                <div-input>
                  <div-card bg="#242424" padding='3vw' radius='2vw'>
                    <van-field :border='false' clearable v-model='bankinfo.bank_name' readonly>
                      <template #label>
                        <div-width width='20vw'>
                          <div-text size='4vw' color='#FFFFFF'>{{ $t('银行名称') }}</div-text>
                        </div-width>
                      </template>
                    </van-field>
                  </div-card>
                </div-input>
                <div-height height='3vw' />
                <div-input>
                  <div-card bg="#242424" padding='3vw' radius='2vw' @click="router(`addbank?type=${info.has_card}`)">
                    <van-field :border='false' clearable v-model='bankinfo.bank_num' readonly is-link>
                      <template #label>
                        <div-width width='20vw'>
                          <div-text size='4vw' color='#FFFFFF'>{{ $t('银行卡号') }}</div-text>
                        </div-width>
                      </template>
                    </van-field>
                  </div-card>
                </div-input>
              </template>
              <template v-else>
                <div-input>
                  <div-card bg="#242424" padding='3vw' radius='2vw' @click="router(`addbank`)">
                    <van-field :border='false' readonly :value="$t('请先维护提现银行卡信息')" is-link />
                  </div-card>
                </div-input>
              </template>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <div-flex left>
                    <div-width width='24vw'>
                      <div-text size='4vw' color='#FFFFFF'>{{ $t('手续费') }}{{ info.withdraw_fee || 0 }}%</div-text>
                    </div-width>
                    <div-text size='4vw' color='#CEB082'>{{ getfee }}</div-text>
                  </div-flex>
                </div-card>
              </div-input>
              <div-height height='3vw' />
              <div-input>
                <div-card bg="#242424" padding='3vw' radius='2vw'>
                  <van-field :border='false' readonly clearable :value="getnum" :placeholder='$t("自动计算")'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('实际到账') }}</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-input>
                <div-height height='3vw' />
                <div-card bg="#242424" padding='3vw' radius='2vw' @click="show = true">
                  <van-field :border='false' readonly clearable right-icon="arrow" :value="getrmb"
                    :placeholder='$t("自动计算")'>
                    <template #label>
                      <div-width width='20vw'>
                        <div-text size='4vw' color='#FFFFFF'>{{ $t('实际到账') }}￥</div-text>
                      </div-width>
                    </template>
                  </van-field>
                </div-card>
              </div-input>
              <div-height height='8vw' />
              <div-btn @click.native="one()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
                <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
              </div-btn>
              <div-height height='10vw' />
            </div>
          </van-tab>
        </van-tabs>
      </template>

      <div v-else>
        <div-height height='8vw' />
        <div-btn radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
          <div-text color='#242424' blod size='4vw'>{{ $t('提现未开启') }}</div-text>
        </div-btn>
        <div-height height='10vw' />
      </div>

      <div-padding padding="4vw 0">
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('提现说明') }}</div-text>
        </div-flex>
      </div-padding>
      <div v-if="active == 1 || active == 2">
        <div-text color='#999' size='4vw'>1U ≈ ￥{{ info.rnb_to_usdt }}</div-text>
        <div-text color='#999' size='4vw'>{{ info.withdraw_rule }}</div-text>
      </div>
      <div v-if="active == 3">
        <div-text color='#999' size='4vw'>{{ info.act_withdraw_rule }}</div-text>
      </div>
      <div-height height='10vw' />
    </div-padding>

    <van-popup class="popupcode" v-model="show_code" style="width: 76%;top:40%;" closeable>
      <div class="content">
        <p>{{ $t('交易密码') }}</p>
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading" @click="pay">
          {{ $t('确定') }}</van-button>
      </div>
    </van-popup>

    <van-popup class="popupcode" style="width: 76%;top:40%;" closeable v-model="show">
      <div class="content">
        <van-radio-group v-model="radio" disabled>
          <van-radio name="1">{{ $t('人民币') }}</van-radio>
          <van-radio name="2">{{ $t('美金') }}</van-radio>
          <van-radio name="2">{{ $t('英镑') }}</van-radio>
          <van-radio name="2">{{ $t('欧元') }}</van-radio>
        </van-radio-group>
      </div>
    </van-popup>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        // [{ id: 1, name: this.$t('钱包提现') },  { id: 2, name: this.$t('银行卡提现') },{ id: 3, name: `ACT${this.$t('提现')}` }],
        taplist: [],
        active: 1,//1.钱包提现  2.银行卡提现 3ACT提现

        usdt: 0,
        act: 0,
        info: {},
        bankinfo: {},

        num: "",
        address: "",
        password: "",
        show_code: false,
        loading: false,
        show: false,
        radio: '1',
      }
    },
    computed: {
      getfee() {
        if (this.num) {
          const fee = Number(this.num) * Number(this.info.withdraw_fee / 100) || 0
          return Number(fee).toFixed(4)
        } else {
          return Number(0).toFixed(4)
        }
      },
      getnum() {
        if (this.num) {
          const fee = Number(this.num) * Number(this.info.withdraw_fee / 100) || 0
          return Number(Number(this.num) - fee).toFixed(4)
        } else {
          return ''
        }
      },
      getrmb() {
        if (this.num) {
          const fee = Number(this.num) * Number(this.info.withdraw_fee / 100) || 0
          const num = Number(Number(this.num) - fee).toFixed(4)
          return Number(num * Number(this.info.rnb_to_usdt || 0)).toFixed(4)
        } else {
          return ''
        }
      },
      getACTfee() {
        if (this.num) {
          const fee = Number(this.num) * Number(this.info.act_withdraw_fee / 100) || 0
          return Number(fee).toFixed(4)
        } else {
          return Number(0).toFixed(4)
        }
      },
    },
    created() {
      if (this.urlQuery().type == 2) {
        this.active = 2
      }
      this.get_info()
      this.getconfig()
    },
    methods: {
      one() {
        if (this.active == 1 || this.active == 3) {
          if (!this.num) return this.$toast(this.$t("请输入提现数量"))
          if (!this.address) return this.$toast(this.$t("请输入提现地址"))
        } else if (this.active == 2) {
          if (this.info.has_card == 0) {
            return this.$dialog.alert({
              title: this.$t('提示'),
              message: this.$t('请先维护提现银行卡信息'),
              confirmButtonText: this.$t('去添加'),
            }).then(() => {
              this.$router.push('addbank')
            });
          }
          if (!this.num) return this.$toast(this.$t("请输入提现数量"))
        }
        this.show_code = true
      },
      pay() {
        let data = {}
        let url = ''
        if (!this.password) return this.$toast(this.$t("请输入交易密码"))
        if (this.active == 1) {
          url = "/api/v1/user/withdraw"
          data = {
            type: 1,
            amount: this.num,
            address: this.address,
            trade_password: this.password,
          }
        } else if (this.active == 2) {
          url = "/api/v1/user/withdraw"
          data = {
            type: 2,
            amount: this.num,
            trade_password: this.password,
          }
        } else if (this.active == 3) {
          url = "/api/v1/withdraw/actWithdraw"
          data = {
            amount: this.num,
            address: this.address,
            trade_password: this.password,
          }
        }

        if (this.loading == true) {
          return this.$toast(this.$t("请勿重复提交"))
        }
        this.loading = true
        this.$post({
          url,
          data,
          success: (res) => {
            this.num = ""
            this.address = ""
            this.password = ""
            this.show_code = false
            this.$toast({
              message: this.$t("操作成功"),
              onClose: () => {
                this.get_info()
                this.loading = false
              }
            })
          },
          tip: () => {
            this.password = ""
            this.loading = false
            this.show_code = false
          },
        })
      },
      formatter(value) {
        value = value.replace(/[^0-9.]/g, "")
        const decimalIndex = value.indexOf(".")
        if (decimalIndex !== -1) {
          value = value.slice(0, decimalIndex + 5)
        }
        return value
      },
      get_info() {
        this.$get({
          url: "/api/v1/user/info",
          success: (res) => {
            this.usdt = res.data.usdt
            this.act = res.data.act
          },
          tip: () => { },
        })
      },
      getconfig() {
        this.$get({
          url: "/api/v1/financial",
          success: (res) => {
            this.info = res.data
            this.taplist = []
            if (res.data.u_withdraw == 1) {
              this.taplist.push({ id: 1, name: this.$t('钱包提现') })
            }
            if (res.data.bank_withdraw == 1) {
              this.taplist.push({ id: 2, name: this.$t('银行卡提现') })
            }
            if (res.data.act_withdraw == 1) {
              this.taplist.push({ id: 3, name: `ACT${this.$t('提现')}` })
            }

            if (res.data.has_card == 1) {
              this.getbank()
            }
          },
          tip: () => { },
        })
      },
      getbank() {
        this.$get({
          url: "/api/v1/user/cards",
          success: (res) => {
            this.bankinfo = res.data
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped>
  /deep/.van-field__control {
    color: #fff !important;
    font-size: 4vw !important;
  }
  .popupcode {
    .content {
      width: 100%;
      /deep/.van-radio-group {
        width: 90%;
        padding: 40px 10px 5px;
        .van-radio {
          margin-bottom: 10px;
        }
      }
    }
  }
</style>